module.exports = __webpack_public_path__ + "static/5-25e1be67b2882316a0ffa10428a9a3b3.png";